import { __read } from "tslib";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';
import { useWindowSizeHook } from '@mercell/use-window-resize-react-hook';
export var Tabs = function (_a) {
    var hideLine = _a.hideLine, children = _a.children, activeKey = _a.activeKey, onTabChange = _a.onTabChange, tabsClassName = _a.tabsClassName, tabContainerClassName = _a.tabContainerClassName, tabContentContainerClassName = _a.tabContentContainerClassName, tabsLineClassName = _a.tabsLineClassName;
    var _b = __read(useState(activeKey), 2), activeTab = _b[0], setActiveTab = _b[1];
    var _c = __read(useState([]), 2), tabs = _c[0], setTabs = _c[1];
    var _d = __read(useState(0), 2), scrollLeft = _d[0], setScrollLeft = _d[1];
    var _e = __read(useState(0), 2), scrollWidth = _e[0], setScrollWidth = _e[1];
    var _f = __read(useState(0), 2), clientWidth = _f[0], setClientWidth = _f[1];
    var ref = useRef(null);
    var width = useWindowSizeHook().width;
    useEffect(function () {
        var _a, _b;
        if (ref.current !== null) {
            setClientWidth((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth);
            setScrollWidth((_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.scrollWidth);
        }
    }, [width]);
    useEffect(function () {
        if (activeKey !== activeTab) {
            setActiveTab(activeKey);
        }
    }, [activeKey, activeTab]);
    useMemo(function () {
        var tabContent = [];
        if (children && Array.isArray(children)) {
            children.forEach(function (child) {
                if (child.props) {
                    tabContent.push({
                        title: child.props.title,
                        tabKey: child.props.tabKey,
                        icon: child.props.icon,
                        onTabClick: function () { return onTabChange(child.props.tabKey); },
                        content: child,
                    });
                }
            });
        }
        setTabs(tabContent);
    }, [children, onTabChange]);
    var handleScrolling = function (event) {
        setScrollLeft(event.target.scrollLeft);
        setScrollWidth(event.target.scrollWidth);
        setClientWidth(event.target.clientWidth);
    };
    var scrolledToEnd = clientWidth === scrollWidth - scrollLeft;
    var scrolledToStart = scrollLeft === 0;
    var scrolledBetween = scrollLeft > 0 && clientWidth < scrollWidth - scrollLeft;
    var handleMobileScrollStyle = function () {
        if (scrolledToStart) {
            return {
                width: clientWidth,
                background: 'linear-gradient(to right, rgba(255,255,255, 0) 95%, rgba(255,255,255, 1) 100%)',
            };
        }
        if (scrolledToEnd) {
            return {
                width: clientWidth,
                background: 'linear-gradient(to left, rgba(255,255,255, 0) 95%, rgba(255,255,255, 1) 100%)',
            };
        }
        if (scrolledBetween) {
            return {
                width: clientWidth,
                background: 'linear-gradient(to right, rgba(255,255,255, 0) 95%, rgba(255,255,255, 1) 100%), linear-gradient(to left, rgba(255,255,255, 0) 95%, rgba(255,255,255, 1) 100%)',
            };
        }
        return {};
    };
    var handleOnClick = function (passedOnTabClick, element) {
        passedOnTabClick();
        if (clientWidth < scrollWidth) {
            if (element.target instanceof Element) {
                element.target.scrollIntoView();
            }
        }
    };
    return (React.createElement("div", { className: cx(tabsClassName) },
        React.createElement("div", null,
            clientWidth < scrollWidth && (React.createElement("div", { style: handleMobileScrollStyle(), className: " h-9 fixed pointer-events-none" })),
            React.createElement("div", { className: twMerge('flex overflow-x-auto whitespace-nowrap', tabContainerClassName), onScroll: handleScrolling, ref: ref }, tabs.map(function (_a) {
                var title = _a.title, tabKey = _a.tabKey, icon = _a.icon, onTabClick = _a.onTabClick;
                return (React.createElement("div", { key: tabKey },
                    React.createElement("button", { key: tabKey, className: cx("flex items-center gap-[0.375rem] text-valhalla leading-5 py-2 px-3 rounded-default z-[25] hover:bg-hover-grey mr-4", tabKey === activeTab &&
                            'bg-snuff text-studio font-semibold hover:bg-snuff'), type: "button", onClick: function (element) {
                            return handleOnClick(onTabClick, element);
                        } },
                        icon,
                        title)));
            }))),
        React.createElement("div", { className: cx(tabsLineClassName) }, !hideLine && (React.createElement("div", { className: "border-b-[1px] border-b-alto my-2" }))),
        React.createElement("div", { className: cx(tabContentContainerClassName) }, tabs.map(function (_a) {
            var tabKey = _a.tabKey, content = _a.content;
            return (React.createElement("div", { key: tabKey }, tabKey === activeTab && React.createElement("div", null, content)));
        }))));
};
